import Vue from 'vue';
import { io } from 'socket.io-client';
import TokenService from './tokenService';

// Uma conexão por aba com o socket do framework (processo socket.js da API, no mesmo domínio do tenant).
// As telas só escutam: this.$socket.on('evento', fn) recebe o que as APIs e jobs mandam com $socket.enviar.

const EVENTO_SESSAO_ENCERRADA = 'clic:sessao-encerrada';
const ESPERA_RECONEXAO_MS = 30000;

let conexao = null;
let aoEncerrarSessao = () => {};
const ouvintes = new Map();

const registrar = (evento, funcao) => {
  if (!ouvintes.has(evento)) ouvintes.set(evento, new Set());
  ouvintes.get(evento).add(funcao);
  if (conexao) conexao.on(evento, funcao);
};

const remover = (evento, funcao) => {
  ouvintes.get(evento)?.delete(funcao);
  if (conexao) conexao.off(evento, funcao);
};

const conectar = () => {
  if (conexao || !TokenService.getLocalAccessToken()) return;
  conexao = io(process.env.VUE_APP_SOCKET_URL || window.location.origin, {
    path: '/socket/',
    transports: ['websocket'],
    auth: (enviar) => enviar({ token: TokenService.getLocalAccessToken() })
  });
  conexao.on(EVENTO_SESSAO_ENCERRADA, () => aoEncerrarSessao());
  conexao.on('connect_error', (erro) => {
    if (erro?.data?.motivo === 'sessao-encerrada') return aoEncerrarSessao();
    const atual = conexao;
    setTimeout(() => {
      if (conexao === atual && !atual.connected && !atual.active) atual.connect();
    }, ESPERA_RECONEXAO_MS);
  });
  for (const [evento, funcoes] of ouvintes) {
    for (const funcao of funcoes) conexao.on(evento, funcao);
  }
};

const desconectar = () => {
  if (!conexao) return;
  conexao.disconnect();
  conexao = null;
};

const instalar = ({ encerrarSessao }) => {
  aoEncerrarSessao = encerrarSessao;
  Object.defineProperty(Vue.prototype, '$socket', {
    configurable: true,
    get() {
      const vm = this;
      return {
        on: (evento, funcao) => {
          registrar(evento, funcao);
          (vm._clicSocketOuvintes || (vm._clicSocketOuvintes = [])).push([evento, funcao]);
        },
        off: (evento, funcao) => {
          remover(evento, funcao);
          if (vm._clicSocketOuvintes) vm._clicSocketOuvintes = vm._clicSocketOuvintes.filter(([e, f]) => e !== evento || f !== funcao);
        }
      };
    }
  });
  Vue.mixin({
    beforeDestroy() {
      if (!this._clicSocketOuvintes) return;
      for (const [evento, funcao] of this._clicSocketOuvintes) remover(evento, funcao);
      this._clicSocketOuvintes = null;
    }
  });
};

export default { instalar, conectar, desconectar };
